import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

export const getDemandeReportsDataTableStructure = (): DynamicDataTable => {
  const societeNomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.form.demande_table.societe_nom',
    accessorKey: 'societeNom',
    variant: DataTableColumnVariant.TEXT,
  };

  const societeNifColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.form.demande_table.societe_nif',
    accessorKey: 'societeNif',
    variant: DataTableColumnVariant.TEXT,
  };

  const societePaysColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.form.demande_table.societe_pays',
    accessorKey: 'societePays',
    variant: DataTableColumnVariant.TEXT,
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'clarification.reports.form.demande_table.date_demande',
    accessorKey: 'createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const motifDemandeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.form.demande_table.motif_demande',
    accessorKey: 'motifDemande',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'clarification.report_request.singular',
    plural: 'clarification.report_request.plural',
    columns: [societeNomColumn, societeNifColumn, societePaysColumn, createdAtColumn, motifDemandeColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    showGridlines: false,
  };
};
